export default __webpack_public_path__ + "8da88a2c5a4cf042316e31b27c594a0f.gif";